import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { motion } from 'framer-motion';
import { api } from '@/lib/api';
import { PositionsTable } from '@/components/PositionsTable';

export const Route = createFileRoute('/positions/')({
  component: PositionsPage,
});

function PositionsPage() {
  const summary = useQuery({ queryKey: ['summary'], queryFn: api.accountSummary });
  const positions = useQuery({
    queryKey: ['positions'],
    queryFn: api.positions,
    refetchInterval: 30_000,
  });
  const orders = useQuery({
    queryKey: ['active-orders'],
    queryFn: api.activeOrders,
    refetchInterval: 60_000,
  });

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      className="space-y-4"
    >
      <div>
        <h1 className="text-xl font-semibold text-zinc-100 tracking-tight">Positions</h1>
        <p className="text-[12px] text-zinc-400 mt-0.5">
          {positions.data?.length ?? 0} open · click a row for detail and chart
        </p>
      </div>
      <PositionsTable
        positions={positions.data ?? []}
        totalValue={summary.data?.totalValue ?? 0}
        activeOrders={orders.data ?? []}
      />
    </motion.div>
  );
}
